export default {
  fontFamily: '"SF Pro Display", "SF Pro Icons", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
  fontWeights: {
    regular: 400,
    bold: 600,
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72],
}
